module.exports = __webpack_public_path__ + "static/img/Q.5ccd806.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SuperAce/Q.png
// module id = Z8R2
// module chunks = 0